/**
 * The project code.
 *
 * @since 0.1.0
 */
export const PROJECT_CODE = 'ryuseicode';

/**
 * The abbreviated project code.
 *
 * @since 0.1.0
 */
export const PROJECT_CODE_SHORT = 'rc';
